import { StatsCard } from "@/components/ui/StatsCard";
import { Users2, PackageCheck } from "lucide-react";
import { Supplier } from "./types";

interface StatsCardsProps {
  suppliers: Supplier[];
}

export const StatsCards = ({ suppliers }: StatsCardsProps) => {
  const totalSuppliers = suppliers.length;
  
  const activeOrders = suppliers.reduce((acc, supplier) => {
    return acc + supplier.supplier_orders.filter(order => order.status === "pending").length;
  }, 0);

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <StatsCard
        title="Total Fournisseurs"
        value={totalSuppliers.toString()}
        icon={Users2}
        description="Nombre total de fournisseurs"
      />
      <StatsCard
        title="Commandes en cours"
        value={activeOrders.toString()}
        icon={PackageCheck}
        description="Commandes en attente de livraison"
      />
    </div>
  );
};